"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function isLocalStorageAvailable() {
    try {
        return window.localStorage ? constants_1.YES : constants_1.NO;
    }
    catch (e) {
        return constants_1.ERROR;
    }
}
exports.isLocalStorageAvailable = isLocalStorageAvailable;
